import { API } from '../../shared/apiRoutes'
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BulkDeleteResponse, CustomerGroupResponse, CustomerResponse, DiscountListRes, PayloadProps, PropertyResponse, RoleBasedResponse, SaveDiscountRes, UpdateDiscountResponse, UpdateRes, discountDetailResponse, duplicateDataProps, duplicateRes, productDropdownRes, updateStatusType } from "../../components/discounts/payXGetFree/payXGetFreeModule";
import { createElement } from 'react';

interface initialData {
    loading: boolean,
    payXDiscountData: DiscountListRes | null,
    deleteResponse: UpdateRes | null,
    bulkDeleteResponse: BulkDeleteResponse | null
    error: string,
    checkDuplicate: { error: string, loading: boolean, value: duplicateRes | null }
    addDiscount: { loading: boolean, error: string, value: SaveDiscountRes | null }
    updateDiscount: { loading: boolean, error: string, value: UpdateDiscountResponse | null }
    getCustomers: { loading: boolean, error: string, value: CustomerResponse | null }
    getCustomerGroup: { loading: boolean, error: string, value: CustomerGroupResponse | null }
    getRoles: { loading: boolean, error: string, value: RoleBasedResponse | null }
    getOnePosDiscount: { loading: boolean, error: string, value: discountDetailResponse | null }
    getFreeProd: { loading: boolean, error: string, value: productDropdownRes | null }
    getAllProperties: { loading: boolean, error: string, value: PropertyResponse | null }
}

interface discountListProps {
    storeId: number,
    data: PayloadProps | undefined
}

interface discountDeleteProps {
    storeId: number,
    data: updateStatusType,
    id: number
}

interface bulkDeleteProps {
    storeId: number,
    selectedItems: number[]
}

interface checkDuplicateProps {
    storeId: number,
    data: duplicateDataProps
}

//initialState
const initialState: initialData = {
    loading: false,
    payXDiscountData: null,
    deleteResponse: null,
    bulkDeleteResponse: null,
    error: '',
    checkDuplicate: { error: '', loading: true, value: null },
    addDiscount: { loading: true, error: '', value: null },
    updateDiscount: { loading: true, error: '', value: null },
    getCustomers: { loading: true, error: '', value: null },
    getCustomerGroup: { loading: true, error: '', value: null },
    getRoles: { loading: true, error: '', value: null },
    getOnePosDiscount: { loading: true, error: '', value: null },
    getFreeProd: { loading: true, error: '', value: null },
    getAllProperties: { loading: true, error: '', value: null }
}

//getAllPosDiscount list call
export const getPayXGetFreePosDiscount = createAsyncThunk('payxDiscount/getAllPosDiscountList', ({ storeId, data }: discountListProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosDiscount, { storeId: storeId })
    return HttpRoutingService?.getMethod<DiscountListRes>(url, data)
})
//activate/deactivate discount list
export const updatePayXGetFreeDiscountStatus = createAsyncThunk("payxDiscount/updatePayXGetFreeDiscountStatus", ({ storeId, data, id }: discountDeleteProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateDiscountStatus, { storeId: storeId, id: id })
    return HttpRoutingService?.putMethod<UpdateRes>(url, data)
})
//single delete discount data call
export const singlePayXGetFreeDelete = createAsyncThunk('payxDiscount/singlePayXGetFreeDelete', ({ storeId, data, id }: discountDeleteProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateDiscountStatus, { storeId: storeId, id: id })
    return HttpRoutingService?.deleteMethod<UpdateRes>(url, data)
})
//bulk delete discount list call
export const bulkDeletePayXgetFreeDiscount = createAsyncThunk('payxDiscount/bulkDeletePayXgetFreeDiscount', ({ storeId, selectedItems }: bulkDeleteProps) => {
    const url = HttpRoutingService.replaceUrl(API.bulkDeleteDiscount, { storeId: storeId })
    return HttpRoutingService.postMethod<BulkDeleteResponse>(url, { id: selectedItems })
})
//check duplicate disocunt title 
export const checkDuplicatesData = createAsyncThunk("payxDiscount/checkDuplicatesData", ({ storeId, data }: checkDuplicateProps) => {
    const url = HttpRoutingService?.replaceUrl("stores/{storeId}/discounts/payxgetfree/existence", { storeId: storeId })
    return HttpRoutingService?.getMethod<duplicateRes>(url, data, "v1/")
})
//add discount
export const addPayXDiscount = createAsyncThunk("payxDiscount/addPayXDiscount", ({ storeId, data }: { storeId: number, data: any }) => {
    const url = HttpRoutingService.replaceUrl(API.addPayXDiscount, { storeId: storeId })
    return HttpRoutingService.postMethod<SaveDiscountRes>(url, data)
})
//update discount
export const updatePayXDiscount = createAsyncThunk("payxDiscount/updatePayXDiscount", ({ storeId, data, id }: { storeId: number, data: any, id: number }) => {
    const url = HttpRoutingService.replaceUrl(API.updatePayXDiscount, { storeId: storeId, id: id })
    return HttpRoutingService.putMethod<UpdateDiscountResponse>(url, data)
})
//get customer data
export const getPosCustomerData = createAsyncThunk("payxDiscount/getPosCustomerData", ({ url, data }: { url: string, data: any }) => {
    return HttpRoutingService.getMethod<CustomerResponse>(url, data, 'v1/');
})
//get customer group data
export const getPosCustomerGroupData = createAsyncThunk("payxDiscount/getPosCustomerGroupData", ({ url, data }: { url: string, data: any }) => {
    return HttpRoutingService.getMethod<CustomerGroupResponse>(url, data);
})
//getRoles
export const getPosRoleBasedData = createAsyncThunk("payxDiscount/getPosRoleBasedData", ({ url, data }: { url: string, data: any }) => {
    return HttpRoutingService.getMethod<RoleBasedResponse>(url, data);
})
//getOne Discount
export const getOnePayxDiscount = createAsyncThunk("payxDiscount/getOnePayxDiscount", ({ storeId, id }: { storeId: number, id: number | undefined }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOneDiscount, { storeId: storeId, id: id })
    return HttpRoutingService?.getMethod<discountDetailResponse>(url)
})
//getFree products data
export const getPayxFreeProductData = createAsyncThunk("payxDiscount/getPayxFreeProductData", ({ storeId, data }: { storeId: number, data: { isFreeProduct: boolean } }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getFreeProductsData, { storeId })
    return HttpRoutingService?.getMethod<productDropdownRes>(url, data, 'v1/')
})
//getAll property
export const getAllPayxPropertyData = createAsyncThunk("payxDiscount/getAllPayxPropertyData", ({ storeId, propertyValues }: { storeId: number, propertyValues: string[] }) => {
    return HttpRoutingService.getMethod<PropertyResponse>('properties/code', { code: JSON.stringify(propertyValues), storeId: storeId });
})

export const PaXDiscountSlice = createSlice({
    name: 'payxDiscount',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder.addCase(getPayXGetFreePosDiscount?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(getPayXGetFreePosDiscount?.fulfilled, (state, action: PayloadAction<DiscountListRes>) => {
            state.loading = false
            state.payXDiscountData = action.payload
        })
        builder.addCase(getPayXGetFreePosDiscount?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in get dicountList'
        })
        builder.addCase(updatePayXGetFreeDiscountStatus?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(updatePayXGetFreeDiscountStatus?.fulfilled, (state, action: PayloadAction<UpdateRes>) => {
            state.loading = false,
                state.deleteResponse = action?.payload
        })
        builder.addCase(updatePayXGetFreeDiscountStatus?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in updateStatus'
        })
        builder.addCase(singlePayXGetFreeDelete?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(singlePayXGetFreeDelete?.fulfilled, (state, action: PayloadAction<UpdateRes>) => {
            state.loading = false,
                state.deleteResponse = action?.payload
        })
        builder.addCase(singlePayXGetFreeDelete?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in delete'
        })
        builder.addCase(bulkDeletePayXgetFreeDiscount?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(bulkDeletePayXgetFreeDiscount?.fulfilled, (state, action: PayloadAction<BulkDeleteResponse>) => {
            state.loading = false,
                state.bulkDeleteResponse = action?.payload
        })
        builder.addCase(bulkDeletePayXgetFreeDiscount?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in delete'
        })
        builder.addCase(checkDuplicatesData.pending, (state) => {
            state.checkDuplicate.loading = true
        })
        builder.addCase(checkDuplicatesData.fulfilled, (state, action: PayloadAction<duplicateRes>) => {
            state.checkDuplicate.loading = false
            state.checkDuplicate.value = action?.payload
        })
        builder.addCase(checkDuplicatesData.rejected, (state, action) => {
            state.checkDuplicate.loading = false
            state.checkDuplicate.error = action?.error?.message ? action?.error?.message : "check duplicate Error "
        })
        builder.addCase(addPayXDiscount.pending, (state) => {
            state.addDiscount.loading = true
        })
        builder.addCase(addPayXDiscount.fulfilled, (state, action: PayloadAction<SaveDiscountRes>) => {
            state.addDiscount.loading = false
            state.addDiscount.value = action?.payload
        })
        builder.addCase(addPayXDiscount.rejected, (state, action) => {
            state.addDiscount.loading = false
            state.addDiscount.error = action?.error?.message ? action?.error?.message : "Error in add discount "
        })
        builder.addCase(updatePayXDiscount.pending, (state) => {
            state.updateDiscount.loading = true
        })
        builder.addCase(updatePayXDiscount.fulfilled, (state, action: PayloadAction<UpdateDiscountResponse>) => {
            state.updateDiscount.loading = false
            state.updateDiscount.value = action?.payload
        })
        builder.addCase(updatePayXDiscount.rejected, (state, action) => {
            state.updateDiscount.loading = false
            state.updateDiscount.error = action?.error?.message ? action?.error?.message : "Error in update discount"
        })
        builder.addCase(getPosCustomerData?.pending, (state) => {
            state.getCustomers.loading = true
        })
        builder.addCase(getPosCustomerData?.fulfilled, (state, action: PayloadAction<CustomerResponse>) => {
            state.getCustomers.loading = false,
                state.getCustomers.value = action?.payload
        })
        builder.addCase(getPosCustomerData?.rejected, (state, action) => {
            state.getCustomers.loading = false
            state.getCustomers.error = action?.error?.message ? action?.error?.message : 'Error in getCustomers'
        })
        builder.addCase(getPosCustomerGroupData?.pending, (state) => {
            state.getCustomers.loading = true
        })
        builder.addCase(getPosCustomerGroupData?.fulfilled, (state, action: PayloadAction<CustomerGroupResponse>) => {
            state.getCustomerGroup.loading = false,
                state.getCustomerGroup.value = action?.payload
        })
        builder.addCase(getPosCustomerGroupData?.rejected, (state, action) => {
            state.getCustomerGroup.loading = false
            state.getCustomerGroup.error = action?.error?.message ? action?.error?.message : 'Error in getCstomerGroup'
        })
        builder.addCase(getPosRoleBasedData?.pending, (state) => {
            state.getRoles.loading = true
        })
        builder.addCase(getPosRoleBasedData?.fulfilled, (state, action: PayloadAction<RoleBasedResponse>) => {
            state.getRoles.loading = false,
                state.getRoles.value = action?.payload
        })
        builder.addCase(getPosRoleBasedData?.rejected, (state, action) => {
            state.getRoles.loading = false
            state.getRoles.error = action?.error?.message ? action?.error?.message : 'Error in getRoles'
        })
        builder.addCase(getOnePayxDiscount?.pending, (state) => {
            state.getOnePosDiscount.loading = true
        })
        builder.addCase(getOnePayxDiscount?.fulfilled, (state, action: PayloadAction<discountDetailResponse>) => {
            state.getOnePosDiscount.loading = false,
                state.getOnePosDiscount.value = action?.payload
        })
        builder.addCase(getOnePayxDiscount?.rejected, (state, action) => {
            state.getOnePosDiscount.loading = false
            state.getOnePosDiscount.error = action?.error?.message ? action?.error?.message : 'Error in getOneDiscount'
        })
        builder.addCase(getPayxFreeProductData?.pending, (state) => {
            state.getFreeProd.loading = true
        })
        builder.addCase(getPayxFreeProductData?.fulfilled, (state, action: PayloadAction<productDropdownRes>) => {
            state.getFreeProd.loading = false,
                state.getFreeProd.value = action?.payload
        })
        builder.addCase(getPayxFreeProductData?.rejected, (state, action) => {
            state.getFreeProd.loading = false
            state.getFreeProd.error = action?.error?.message ? action?.error?.message : 'Error in getFreeProducts'
        })
        builder.addCase(getAllPayxPropertyData?.pending, (state) => {
            state.getAllProperties.loading = true
        })
        builder.addCase(getAllPayxPropertyData?.fulfilled, (state, action: PayloadAction<PropertyResponse>) => {
            state.getAllProperties.loading = false,
                state.getAllProperties.value = action?.payload
        })
        builder.addCase(getAllPayxPropertyData?.rejected, (state, action) => {
            state.getAllProperties.loading = false
            state.getAllProperties.error = action?.error?.message ? action?.error?.message : 'Error in getAllProperties'
        })
    }
})

export default PaXDiscountSlice?.reducer